// Plausible Analytics loader — no-op unless REACT_APP_PLAUSIBLE_DOMAIN is set.
// Uses the standard plausible.io hosted script and injects it once, client-side.
const SCRIPT_ID = 'plausible-analytics-script';

export function loadPlausible() {
  if (typeof window === 'undefined') return;
  const domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
  if (!domain) return;
  if (document.getElementById(SCRIPT_ID)) return;

  const s = document.createElement('script');
  s.id = SCRIPT_ID;
  s.defer = true;
  s.setAttribute('data-domain', domain);
  s.src = 'https://plausible.io/js/script.js';
  document.head.appendChild(s);

  // Queue helper so we can call window.plausible('event') before the script loads
  window.plausible =
    window.plausible ||
    function () {
      (window.plausible.q = window.plausible.q || []).push(arguments);
    };
}
